import { render, staticRenderFns } from "./ContratoFornecedorPage.vue?vue&type=template&id=deda1244&"
import script from "./ContratoFornecedorPage.vue?vue&type=script&lang=js&"
export * from "./ContratoFornecedorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports